module.exports = __webpack_public_path__ + "static/media/PPT-prev-active.38d82288.svg";